import { Logo } from '@/assets/images/Logo';
import { Button, Text } from '../ui';
import {
  BellIcon,
  BriefcaseIcon,
  GaugeIcon,
  ChartLineIcon,
  FileDownIcon,
  FileTextIcon,
  LayoutDashboardIcon,
  LogOutIcon,
  SettingsIcon,
  TicketsIcon,
  UserIcon,
  UsersIcon,
  UserCog,
} from 'lucide-react';
import { NavItem } from './NavItem';
import { canAccessRoute } from '@console/utils';
import { useAuthStore } from '@/lib/auth/store';
import { useAuth } from '@/lib/auth/context';
import { useTranslation } from 'react-i18next';
import { useUnreadNotifications } from '@/hooks/useNotifications';

export function Sidebar() {
  const { user } = useAuthStore();
  const { logout } = useAuth();
  const { t } = useTranslation();
  const { unreadCount } = useUnreadNotifications();

  const handleLogout = async () => {
    await logout();
  };
  return (
    <aside className="px-2xs py-md flex w-[226px] flex-col">
      <Logo className="self-center" />

      <nav className="py-lg gap-2xs flex flex-1 flex-col">
        <NavItem label={t('sidebar.dashboard')} to="/" icon={<LayoutDashboardIcon size={20} />} />
        <NavItem
          label={t('sidebar.notifications')}
          to="/notifications"
          icon={<BellIcon size={20} />}
          hasNotification={unreadCount > 0}
        />
        <NavItem label={t('sidebar.contracts')} to="/contracts" icon={<FileTextIcon size={20} />} />
        <NavItem label={t('sidebar.tickets')} to="/tickets" icon={<TicketsIcon size={20} />} />
        <NavItem
          label={t('sidebar.monthlyConsumption')}
          to="/monthly-consumptions"
          icon={<ChartLineIcon size={20} />}
        />
        <hr className="border-neutral-subtle" />
        {user && canAccessRoute(user.role, ['ADMIN', 'VIEWER']) && (
          <NavItem
            label={t('sidebar.contractPortfolio')}
            to="/reports/contract-portfolio"
            icon={<BriefcaseIcon size={20} />}
          />
        )}
        {user && canAccessRoute(user.role, ['ADMIN', 'VIEWER']) && (
          <NavItem
            label={t('sidebar.resourceAllocation')}
            to="/reports/resource-allocation"
            icon={<GaugeIcon size={20} />}
          />
        )}
        <NavItem label={t('sidebar.reports')} to="/reports" icon={<FileDownIcon size={20} />} />
        <NavItem label={t('sidebar.users')} to="/users" icon={<UsersIcon size={20} />} />
        <NavItem label={t('sidebar.groups')} to="/groups" icon={<UserCog size={20} />} />
        <NavItem label={t('sidebar.settings')} to="/settings" icon={<SettingsIcon size={20} />} />
        <NavItem label={t('sidebar.me')} to="/me" icon={<UserIcon size={20} />} />
      </nav>

      <footer className="flex items-center justify-between">
        <div>
          <Text variant="label" strong>
            {user?.name}
          </Text>
          <Text variant="label" size="xs" className="text-neutral-muted">
            {user?.email}
          </Text>
        </div>
        <Button variant="secondary" size="smIcon" onClick={handleLogout}>
          <LogOutIcon size={20} />
        </Button>
      </footer>
    </aside>
  );
}
